import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined"
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined"
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined"
import { Box, Grid, IconButton, Tooltip } from "@mui/material"
import React, { useCallback, useContext, useState } from "react"
import { customPalette } from "../../../../../../theme"
import { ImageDisplayer } from "../../../../../components/image-displayer/image-displayer"
import { TabEnum } from "../../../../../components/tabs/tabs"
import { CoverImgProjectContext } from "../../../../../core/context/project/CoverImgProjectContext"
import { ProjectForm } from "../../../components/ProjectForm"
import { DeleteProjectDialog } from "../../beem-shot/variant/components/Dialog/DeleteProjectDialog"
import { UpdateProjectStatusDialog } from "../../beem-shot/variant/components/Dialog/UpdateProjectStatusDialog"
import { ProjectBeemModelCard } from "./components/ProjectBeemModelCard"
import { ProjectInfoDisplayer } from "./components/ProjectInfoDisplayer"
import { ProjectTeamCard } from "./components/ProjectTeamCard"
import { ProjectVariantDisplayerCard } from "./components/ProjectVariantDisplayerCard"

type IProps = {
  handleChange(event: React.SyntheticEvent, newValue: TabEnum): void
}

export function ProjectGeneralTab({ handleChange }: Readonly<IProps>): React.JSX.Element {
  const { file } = useContext(CoverImgProjectContext)

  const [openUpdateVariantInfo, setOpenUpdateVariantInfo] = useState<boolean>(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false)
  const [openManageProjectStatus, setOpenManageProjectStatus] = useState<boolean>(false)

  const handleClose: () => void = useCallback(() => {
    setOpenUpdateVariantInfo(false)
  }, [])

  return (
    <Grid container mt={1} spacing={1}>
      <Grid item xs={12} container borderRadius={3} sx={{ background: customPalette.white }} columnSpacing={2}>
        <Grid item xs={3} display="flex" justifyContent="center">
          <Box p={1}>
            <ImageDisplayer file={file} height="250px" width="250px" isLoading={false} />
          </Box>
        </Grid>

        <Grid container item xs={7}>
          <ProjectInfoDisplayer />
        </Grid>

        <Grid container item xs={2} alignItems="flex-start" justifyContent="flex-end">
          <Tooltip title="Modifier les informations" placement="bottom" arrow>
            <IconButton
              onClick={() => setOpenUpdateVariantInfo(true)}
              sx={{ background: customPalette.lightGray6, borderRadius: 2, mr: 1, mt: 1 }}>
              <CreateOutlinedIcon sx={{ color: customPalette.lightBlue2 }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Supprimer le projet" placement="bottom" arrow>
            <IconButton
              onClick={() => setOpenDeleteDialog(true)}
              sx={{ background: customPalette.lightGray6, borderRadius: 2, mr: 1, mt: 1 }}>
              <DeleteOutlineOutlinedIcon sx={{ color: customPalette.lightBlue2 }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Gérer l'état du projet" placement="bottom" arrow>
            <IconButton
              onClick={() => setOpenManageProjectStatus(true)}
              sx={{ background: customPalette.lightGray6, borderRadius: 2, mr: 1, mt: 1 }}>
              <SettingsOutlinedIcon sx={{ color: customPalette.lightBlue2 }} />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>

      <Grid container item xs={5}>
        <ProjectTeamCard handleChange={handleChange} />
      </Grid>

      <Grid container item xs={5}>
        <ProjectBeemModelCard handleChange={handleChange} />
      </Grid>

      <Grid container item xs={2}>
        <ProjectVariantDisplayerCard />
      </Grid>

      <ProjectForm open={openUpdateVariantInfo} handleClose={handleClose} />

      <DeleteProjectDialog open={openDeleteDialog} setOpen={setOpenDeleteDialog} />

      <UpdateProjectStatusDialog open={openManageProjectStatus} setOpen={setOpenManageProjectStatus} />
    </Grid>
  )
}
